import type { Dispatch, UnknownAction } from 'redux'
import { addToasty } from '../../toasty/actions'

const DEFAULT_MESSAGE = 'Something went wrong. Please try again.'

/**
 * Dispatches a toast with the given error message.  Callers extract the
 * translated string from their `staticText` Immutable Map themselves and
 * pass it here as a primitive — this keeps the call site's useCallback /
 * useEffect deps free of the whole Map, so identity churn on the Map
 * doesn't ripple into invalidating the caller's callbacks.
 *
 * Falls back to DEFAULT_MESSAGE when the provided message is empty /
 * undefined / null so callers can pass `staticText.getIn([...])` directly
 * without a local `||` fallback.
 */
export default function showSaveErrorToast (
  dispatch: Dispatch<UnknownAction>,
  message?: string | null,
): void {
  const resolved = message && message.length > 0 ? message : DEFAULT_MESSAGE
  dispatch(addToasty(resolved))
}
